<template>
    <div class='page-start'>
      <mdb-container class="col-10 pb-3" fluid>
  
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
          Success! Submitted STR! Go back to View the Build?
          <mdbBtn class="QuadrusButton" v-on:click="returnToView">Yes</mdbBtn>
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
            There was an error submitting STR. Please try again! Error Code P2
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p3" @closeAlert="p3=false" dismiss>
            Missing required fields.
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
            Please enter a valid author name.
        </mdb-alert>
  
        <mdb-card class="mb-3 d-flex">
          <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">STR Form</h3>
          <mdb-card-body>
            <form class="was-validated" @submit.prevent="" novalidate>
              <h5 class="STR-heading">1.1  Author</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input class="mb-3" :disabled="!editing" v-model="author" label="Author" @input="checkName"
                  maxlength="60" required />
                  <div v-if="!author" class="invalid-feedback d-block">Please Input Author</div>
                  <div v-else-if="!validName" class="invalid-feedback d-block">Please Input a valid name</div>
                  <div v-else-if="validName" class="valid-feedback d-block">Looks Good!</div>
                </mdb-col>
              </mdb-row>
              <br>
              <h4 class="STR-heading">1.  Scope</h4>
              <h5 class="STR-heading">1.1  Identification</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="identification" label="Identification" invalid-feedback="Please Input Identification" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>

              <h5 class="STR-heading">1.2  System Overview</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="sysOverview" label="Overview" invalid-feedback="Please Input Overview" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h4 class="STR-heading">2.  Document Overview</h4>
              <h5 class="STR-heading">2.1  Government Documents</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" v-model="govDocs" :disabled="!editing" label="Government Documents" invalid-feedback="Please Input Documents" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h5 class="STR-heading">2.2  Non-Government Documents</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" v-model="nonGovDocs" :disabled="!editing" label="Non-Government Documents" invalid-feedback="Please Input Documents" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h5 class="STR-heading">2.3  Order of Precedence</h5>
              <mdb-row>
                <mdb-col>
                    <p>In the event of a conflict between the text of this document and the references cited herein, the text of this document takes precedence, unless otherwise specified. Nothing in this document, however, supersedes applicable laws and regulations unless a specific exemption has been obtained.</p>
                    <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="precedence" label="Order of Precedence" invalid-feedback="Please Input Precedence" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>

              <h4 class="STR-heading">3.  Overview of Results</h4>
              <h5 class="STR-heading">3.1  Overall Assessment of the Software Tested</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="assessment" label="Assessment" invalid-feedback="Please Input assessment" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h5 class="STR-heading">3.2  Impact of Test Environment</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="environmentImpact" label="Impact" invalid-feedback="Please Input Impact" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h5 class="STR-heading">3.3  Recommended Improvements</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="improvements" label="Improvements" invalid-feedback="Please Input improvements" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
                            
              <h4 class="STR-heading">4.  Detailed Test Results</h4>
              <h5 class="STR-heading">4.1  1st Project-unique identifier for detailed test results</h5>
              <h6 class="STR-heading">4.1.1  Summary of the test results</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="testResults1" label="Summary" invalid-feedback="Please Input Results" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="STR-heading">4.1.2  Problems encountered</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="problems1" label="Problems" invalid-feedback="Please Input Results" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>

              <h5 class="STR-heading">4.2  2nd Project-unique identifier for detailed test results</h5>
              <h6 class="STR-heading">4.2.1  Summary of the test results</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="testResults2" label="Summary" invalid-feedback="Please Input Summary" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="STR-heading">4.2.2  Problems encountered</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="problems2" label="Problems" invalid-feedback="Please Input Problems" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="STR-heading">4.2.3  Deviations from Test Cases/Procedures</h6>
              <h6 class="STR-heading">4.2.3.1  1st Project-unique identifier of a test case</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="deviation1" label="1st identifier" invalid-feedback="Please Input Identifier" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="STR-heading">4.2.3.2  2nd Project-unique identifier of a test case</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="deviation2" label="2nd identifier" invalid-feedback="Please Input Identifier" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>

              <h4 class="STR-heading">5.  Test Log</h4>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="testLog" label="Test Log" invalid-feedback="Please Input Test Log" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h4 class="STR-heading">6.  Notes</h4>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing" v-model="notes" label="Notes" invalid-feedback="Please Input Notes" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>


              <mdb-btn class='QuadrusButton' v-on:click="submitSTR" type="submit" v-if="!submitProcessing && editing">Submit</mdb-btn>
              <mdb-btn class='QuadrusButton' v-if="submitProcessing">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Processing...
              </mdb-btn>

              <mdb-btn class='QuadrusButton' v-on:click="returnToView" type="submit" v-if="!editing">Done</mdb-btn>
              <br>
              <mdb-btn v-if="editing" color="danger" v-on:click="clearSTRForm">Clear</mdb-btn>
            </form>
          </mdb-card-body>
        </mdb-card>
      </mdb-container>
    </div>
  </template>
  
<style>
    .STR-heading{text-align: left;}
</style>

  <script>
  import { mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbBtn, mdbCol, mdbRow, mdbAlert } from 'mdbvue';
  import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
  import * as sanitizeInput from '@/assets/js/sanitizeInput.js';
  
  export default {
      name: 'STRForm',
      components: {
      mdbInput,
      mdbCard,
      mdbCardBody,
      mdbContainer,
      mdbBtn,
      mdbCol, 
      mdbRow,
      mdbAlert
      },
    data() {
        return {
  
          p1: false,
          p2: false,
          p3: false,
          p4: false,
          buildId: '',
          STRNumber: '',
          validName: false,
          
          editing: false,
          author: '',
          identification: '',
          sysOverview: '',
          govDocs: '',
          nonGovDocs: '',
          precedence: '',
          assessment: '',
          environmentImpact: '',
          improvements: '',
          testResults1: '',
          problems1: '',
          testResults2: '',
          problems2: '',
          deviation1: '',
          deviation2: '',
          testLog: '',
          notes: '',
          
          submitProcessing: false,

        }
    },

    props: 
    {
      loadBuild: 
      {
        id: String,
        STRNumber: Number,
        editing: Boolean,
        default: null
      }
    },

    methods: {

      //===========================================================================================
      //	Method Name	:	loadSTRData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Loads data if an STR already exists
      //===========================================================================================
      loadSTRData: async function(){
        let token = this.$store.getters.getToken;
        let query = "filters[id][$in][0]=" + this.STRNumber;
        let response = await DatabaseLib.getRequest('strapiDatabase','strs',token,query,false);

        this.identification = response.data.data[0].attributes.identification;
        this.sysOverview = response.data.data[0].attributes.sysOverview;
        this.govDocs = response.data.data[0].attributes.govDocs;
        this.nonGovDocs = response.data.data[0].attributes.nonGovDocs;
        this.precedence = response.data.data[0].attributes.precedence;
        this.assessment = response.data.data[0].attributes.assessment;
        this.environmentImpact = response.data.data[0].attributes.environmentImpact;
        this.improvements = response.data.data[0].attributes.improvements;
        this.testResults1 = response.data.data[0].attributes.testResults1;
        this.problems1 = response.data.data[0].attributes.problems1;
        this.problems2 = response.data.data[0].attributes.problems2;
        this.testResults2 = response.data.data[0].attributes.testResults2;
        this.deviation1 = response.data.data[0].attributes.deviation1;
        this.deviation2 = response.data.data[0].attributes.deviation2;
        this.testLog = response.data.data[0].attributes.testLog;
        this.notes = response.data.data[0].attributes.notes;
        this.author = response.data.data[0].attributes.author;
      },

      //===========================================================================================
      //	Method Name	:	clearSTRForm
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Clears the form
      //===========================================================================================
      clearSTRForm: function() {
        this.identification = '';
        this.sysOverview = '';
        this.govDocs = '';
        this.nonGovDocs = '';
        this.precedence = '';
        this.assessment = '';
        this.environmentImpact = '';
        this.improvements = '';
        this.testResults1 = '';
        this.problems1 = '';
        this.testResults2 = '';
        this.problems2 = '';
        this.deviation1 = '';
        this.deviation2 = '';
        this.testLog = '';
        this.notes = '';
        this.author = '';
      },

      checkName: function(name){
        let nameRegex = new RegExp(/^[\p{L}]+(?:[ '’.-][\p{L}]+)*$/u);
        if(nameRegex.test(name)){
          this.validName = true;
        } else {
          this.validName = false;
        }
      },
  
      //===========================================================================================
      //	Method Name	:	submitSTR
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Submits an STR
      //===========================================================================================
      submitSTR: async function() {
        this.p2 = false;
        this.p3 = false;
        this.p4 = false;

        if(!this.validName){
          this.p4 = true;
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
        if(!this.author || !this.identification || !this.sysOverview || !this.govDocs || !this.nonGovDocs || !this.precedence  
          || !this.assessment || !this.environmentImpact || !this.improvements || !this.testResults1 || !this.testResults2 
          || !this.problems1 || !this.problems2 || !this.deviation1 || !this.deviation2 || !this.testLog || !this.notes 
        ){
          this.p3 = true;
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }

        this.submitProcessing = true;
        let token = this.$store.getters.getToken;
  
        this.identification = sanitizeInput(this.identification, this.$sanitize);
        this.sysOverview = sanitizeInput(this.sysOverview, this.$sanitize);
        this.govDocs = sanitizeInput(this.govDocs, this.$sanitize);
        this.nonGovDocs = sanitizeInput(this.nonGovDocs, this.$sanitize);
        this.precedence = sanitizeInput(this.precedence, this.$sanitize);
        this.assessment = sanitizeInput(this.assessment, this.$sanitize);
        this.environmentImpact = sanitizeInput(this.environmentImpact, this.$sanitize);
        this.improvements = sanitizeInput(this.improvements, this.$sanitize);
        this.testResults1 = sanitizeInput(this.testResults1, this.$sanitize);
        this.problems1 = sanitizeInput(this.problems1, this.$sanitize);
        this.testResults2 = sanitizeInput(this.testResults2, this.$sanitize);
        this.problems2 = sanitizeInput(this.problems2, this.$sanitize);
        this.deviation1 = sanitizeInput(this.deviation1, this.$sanitize);
        this.deviation2 = sanitizeInput(this.deviation2, this.$sanitize);
        this.testLog = sanitizeInput(this.testLog, this.$sanitize);
        this.notes = sanitizeInput(this.notes, this.$sanitize);
        this.author = sanitizeInput(this.author, this.$sanitize);
  
        let data = {
          data: {
            identification: this.identification,
            sysOverview: this.sysOverview,
            govDocs: this.govDocs,
            nonGovDocs: this.nonGovDocs,
            precedence: this.precedence,
            assessment: this.assessment,
            environmentImpact: this.environmentImpact,
            improvements: this.improvements,
            testResults1: this.testResults1,
            problems1: this.problems1,
            testResults2: this.testResults2,
            problems2: this.problems2,
            deviation1: this.deviation1,
            deviation2: this.deviation2,
            testLog: this.testLog,
            notes: this.notes,
            author: this.author
          }
        }
        try {
          let response = '';
          if(this.STRNumber){
            response = await DatabaseLib.putRequest('strapiDatabase','strs',token,this.STRNumber,data);
          } else {
            response = await DatabaseLib.postRequest('strapiDatabase','strs',token,data);
          }
          
          // update build stage and add STRNumber
          data = {
            data: {
              STRNumber: response.data.data.id,
              stage: "Project Closeout CCB"
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);

          this.p1 = true;
          this.editing = false;
          window.scroll({top: 0, behavior: 'smooth'});
          this.submitProcessing = false;
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2 = true;
          this.submitProcessing = false;
          return;
        }
      },
  
      //===========================================================================================
      //	Method Name	:	sanitizeInput
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Cleans up data
      //===========================================================================================
      sanitizeInput(content) {
        return this.$sanitize(content)
      },

      //===========================================================================================
      //	Method Name	:	returnToView
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Goes back to previous page when viewing QIP
      //===========================================================================================
      returnToView: function(){
        this.$router.push({
          name: 'ViewEditBuild',
          query: {
            id: this.buildId,
            project: null
          }
        })
      },

      //===========================================================================================
      //	Method Name	:	bindProps
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Loads data passed to the page
      //===========================================================================================
      bindProps: function(){
        if(this.loadBuild != null){
          this.buildId = this.loadBuild.id;
          this.STRNumber = this.loadBuild.STRNumber;
          this.editing = this.loadBuild.editing;
          if(this.STRNumber){
            this.loadSTRData();
          }
        }
      }

    },
    mounted(){
      window.scroll({top: 0, behavior: 'smooth'});
      this.bindProps();
    }
  }
  </script>